"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var StyleStaticText = /** @class */ (function (_super) {
    __extends(StyleStaticText, _super);
    function StyleStaticText() {
        var _this = _super.call(this) || this;
        _this.styleStaticTexts = function () {
            var _a;
            (_a = _this.staticTexts) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                var chars = { '{': '<span class="highlighted linetype" data-linetype>', '}': '</span>' };
                var textContent = element.textContent;
                var name = sessionStorage.getItem('name');
                if (name !== null) {
                    textContent = textContent.replace('Name!', "".concat(name, "!"));
                }
                element.innerHTML = textContent.replace(/[{}]/g, function (m) { return chars[m]; });
            });
        };
        var fieldset = document.querySelector('fieldset');
        _this.setElement(fieldset);
        _this.staticTexts = _this.getChildElements("[".concat(constants_1.DATA_FORM_STATIC_TEXT, "]"));
        // Replace chars in static form texts on load
        _this.styleStaticTexts();
        return _this;
    }
    return StyleStaticText;
}(abstractComponent_1.default));
exports.default = StyleStaticText;
